/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { StreemApiGlobalGetCentralLoginPublicLoginConfigResponseFromJSON, } from '../models';
/**
 *
 */
export class CentralLoginApi extends runtime.BaseAPI {
    /**
     * Get the public login configuration for the FusionAuth Centralized Login Application, determining how to log in
     * Get Centralized Login Application Public Login Config
     */
    async getCentralLoginPublicLoginConfigurationRaw() {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/central-login/public-login-configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGlobalGetCentralLoginPublicLoginConfigResponseFromJSON(jsonValue));
    }
    /**
     * Get the public login configuration for the FusionAuth Centralized Login Application, determining how to log in
     * Get Centralized Login Application Public Login Config
     */
    async getCentralLoginPublicLoginConfiguration() {
        const response = await this.getCentralLoginPublicLoginConfigurationRaw();
        return await response.value();
    }
}
//# sourceMappingURL=CentralLoginApi.js.map